import { atom } from "recoil";
import { recoilPersist } from "recoil-persist";

const { persistAtom } = recoilPersist();

const instructionState = atom({
  key: "instructionState",
  effects_UNSTABLE: [persistAtom],
  default: null,
});

export default instructionState;
